//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */
const pagenoutfound = () => import('../components/pagenoutfound.vue')
import home from '@/components/home'
import homelogs from '@/components/home-logs'
import homeAtls from '@/components/home-atls'
import homeDivision from '@/components/home-division'
import logs_search from '@/components/logs/logs_search'
import logs_print from '@/components/logs/logs_print'
import logs_admin from '@/components/logs/logs_admin'

export const routes = [
    /*General routes*/
    { name: 'home', path: '/', component: home, display: 'Home', icon: 'Home' },

    /* Log routes*/
    { name: 'home-logs', path: '/logs', component: homelogs, display: 'Home-Logs', icon: 'Home' },
    { name: 'logs-search', path: '/logs/search', component: logs_search, display: 'Logs-Search', icon: 'Home', props: true },
    { name: 'logs-print', path: '/logs/print', component: logs_print, display: 'Logs-Print', icon: 'Home', props: true },
    { name: 'logs-admin', path: '/logs/admin', component: logs_admin, display: 'Logs-Admin', icon: 'Home', props: false },
    // Everyting after this is a divison
    {
        name: 'home-divisions',
        path: '/logs/:division',
        component: homeDivision,
        display: 'Home-Divisions',
        icon: 'Home',
    },

    /*ATL routes*/
    { name: 'home-atls', path: '/atls', component: homeAtls, display: 'Home-Atls', icon: 'Home' },

    { name: 'not-found', path: '/:pathMatch(.*)*', component: pagenoutfound },


]
